import React, { useEffect, useState } from "react";
import { Column } from "@ant-design/plots";
import styled from "@emotion/styled";
import COLORS from "common/Colors";
import { Spin } from "antd";
import { concat, includes, isNaN, map, max, size } from "lodash";
import { connect } from "react-redux";
import { getAllDepartmentList } from "redux/selectors";
import { useTranslation } from "react-i18next";

const StyledTitle = styled.div`
  font-size: 0.9rem;
  font-weight: bold;
  color: #141414;
  margin-bottom: 10px;
`;

const StyledChartContainer = styled.div`
  border: solid 1px #9b9b9b;
  border-radius: 3px;
  padding: 20px;
  margin-bottom: 25px;
  .name-title {
    padding: 3px 10px;
    font-size: 1rem;
    padding-bottom: 15px;
  }
`;

function ProductivityOvertime({ allDepartmentList }) {
  const { t } = useTranslation();
  const [displayReportLoader, toggleReportLoader] = useState(false);
  const [reportData, setReportData] = useState([
    { type: "Fintech", ratio: 1 },
    { type: "Leisure", ratio: 13 },
    { type: "Logistics", ratio: 10 },
    { type: "Property", ratio: 32 },
    { type: "Corporate", ratio: 13 },
    { type: "Group", ratio: 4 },
  ]);

  const mappedCollections = allDepartmentList.map((val) => ({
    type: val.short_department_name,
    ratio: 15.5,
  }));

  const config = {
    data: mappedCollections,
    height: 300,
    xField: "type",
    yField: "ratio",
    seriesField: "type",
    label: {
      position: "middle",
      content: "",
    },
    columnStyle: {
      cursor: "pointer",
    },
    legend: false,
    yAxis: {
      max: isNaN(max(map(reportData, "ratio")))
        ? 100
        : max(map(reportData, "ratio")) + 15,
      grid: {
        line: {
          style: {
            opacity: 0,
          },
        },
      },
    },
    xAxis: {
      label: {
        formatter: (value) => value.slice(0, 3),
        offset: 10,
        autoHide: false,
        autoRotate: true,
      },
    },
    theme: {
      colors10: [
        "#2B67BA",
        "#3C88C0",
        "#4BA7B3",
        "#5AC39B",
        "#6ADD7F",
        "#A8DD6A",
        "#DDDD6A",
      ],
    },
  };

  return (
    <>
      <StyledTitle>{t("Overtime: Basic Salary Ratio")}</StyledTitle>
      <StyledChartContainer>
        <Spin spinning={displayReportLoader}>
          <Column {...config} />
        </Spin>
      </StyledChartContainer>
    </>
  );
}

const mapStateToProps = (state) => ({
  allDepartmentList: getAllDepartmentList(state),
});

export default connect(mapStateToProps)(ProductivityOvertime);
